import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { MUNI_DETAIL_INPUT_HEIGHT, muniDetailInputShellSx } from './constants.js';

function MuniDetailFieldPlaceholder() {
  return (
    <Box sx={{ position: 'relative', flex: 1, minWidth: 0, pb: 0.25, m: 0 }}>
      <Box
        sx={{
          ...muniDetailInputShellSx(),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: MUNI_DETAIL_INPUT_HEIGHT,
          maxHeight: MUNI_DETAIL_INPUT_HEIGHT,
        }}
      >
        <CircularProgress size={18} />
      </Box>
    </Box>
  );
}

export default React.memo(MuniDetailFieldPlaceholder);
